import { FC } from 'react';

import Table from 'modules/_shared/Table';

import InvalidRecipientsTableHeader from './InvalidRecipientsTableHeader';
import InvalidRecipientsTableBody from './InvalidRecipientsTableBody';

const InvalidRecipientsTable: FC = () => {
  const tableContent = (
    <>
      <InvalidRecipientsTableHeader />
      <InvalidRecipientsTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default InvalidRecipientsTable;
